<template>
	<div class="user-info">
		<nav-bar :border="false" :left-arrow="true" @click-left="back" title="个人信息"></nav-bar>

		<div class="info-section">
			<h2 class="section-title">个人信息
				<div @click="refresh" class="fr">
					<icon name="replay" />
					刷新数据
				</div>
			</h2>
			<div class="page-card">
				<cell-group>
					<cell title="昵称" :value="info.name" />
					<cell title="等级" :value="info.lv" />
					<cell title="等级星星" :value="info.loyaltyPoints" />
					<cell title="好礼星星" :value="info.rewardPoints" />
				</cell-group>
			</div>
		</div>

		<!-- 星礼卡 -->
		<h2 class="section-title cards-title">星礼卡
			<span v-if="info.svcCards && info.svcCards.length" class="total-balance">总余额: {{ totalBalance }}</span>
		</h2>

		<div class="cards-section">
			<router-link :to="getURL(item.cardNum)" class="page-card" v-for="(item, index) in info.svcCards" :key="'svc-'+index">
				<div class="card-item">
					<div class="card-content">
						<div class="card-label">卡号</div>
						<div class="card-value">{{ item.cardNum }}</div>
					</div>
					<div class="card-content">
						<div class="card-label">余额</div>
						<div class="card-value balance">{{ item.balance }} ›</div>
					</div>
				</div>
			</router-link>
			<div v-if="!info.svcCards || !info.svcCards.length" class="empty-tip">暂无星礼卡</div>
		</div>

		<!-- 星礼包 -->
		<h2 class="section-title cards-title">星礼包</h2>

		<div class="cards-section">
			<div class="page-card" v-for="(item, index) in info.srkits" :key="'srk-'+index">
				<div class="card-item">
					<div class="card-content">
						<div class="card-label">卡号</div>
						<div class="card-value">{{ item.cardNum }}</div>
					</div>
					<div class="card-content">
						<div class="card-label">说明</div>
						<div class="card-value desc">{{ item.description }}</div>
					</div>
				</div>
			</div>
			<div v-if="!info.srkits || !info.srkits.length" class="empty-tip">暂无星礼包</div>
		</div>
	</div>
</template>

<script>
	import {
		getUserInfo
	} from '@/api';
	import {
		Cell,
		Icon,
		NavBar,
		CellGroup
	} from 'vant';
	import store from '../../store'

	export default {
		data() {
			return {
				info: {},
				phone: store.state.phone,
				sign: store.state.sign,
			};
		},
		computed: {
			totalBalance() {
				if (!this.info.svcCards || !this.info.svcCards.length) {
					return 0;
				}
				return this.info.svcCards.reduce((sum, card) => {
					return sum + (parseFloat(card.balance) || 0);
				}, 0);
			}
		},
		methods: {
			getURL(cardNum) {
				return {
					path: '/',
					query: {
						s: this.sign,
						p: this.phone,
						cardNum: cardNum
					}
				};
			},
			back() {
				this.$router.back();
			},
			refresh() {
				this.info = {};
				this.getUserInfo({
					refresh: 1
				});
			},
			async getUserInfo(data = {}) {
				const res = await getUserInfo(data);
				if (res.code === 0) {
					this.info = res.data || {};
				}
			}
		},
		components: {
			Cell,
			CellGroup,
			NavBar,
			Icon
		},
		mounted() {
			this.getUserInfo();
		},
	};
</script>

<style lang="scss" scoped>
.user-info {
	min-height: 100vh;
	background: linear-gradient(180deg, #f5f7fa 0%, #e4e7ed 100%);
}

::v-deep .van-nav-bar {
	background: #fff;

	.van-nav-bar__title {
		color: #333 !important;
		font-size: 28px;
	}

	.van-icon {
		color: #333 !important;
	}
}

.info-section {
	padding: 20px 30px 0;
}

.cards-title {
	padding: 0 30px;
}

.cards-section {
	padding: 0 30px;
	max-height: 600px;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
}

.section-title {
	font-size: 28px;
	font-weight: 600;
	margin: 24px 0 16px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #303133;
}

.fr {
	font-size: 22px;
	color: #409eff;
	font-weight: 500;
	display: flex;
	align-items: center;
	gap: 8px;
}

.total-balance {
	font-size: 22px;
	color: #e6a23c;
	font-weight: 600;
	background: linear-gradient(135deg, #fdf6ec, #faecd8);
	padding: 8px 16px;
	border-radius: 20px;
}

.page-card {
	border-radius: 20px;
	overflow: hidden;
	background: #fff;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
	margin-bottom: 16px;
}

a.page-card {
	text-decoration: none;
	display: block;
}

.card-item {
	padding: 24px;
}

.card-content {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 12px 0;
	border-bottom: 1px solid #f2f6fc;

	&:last-child {
		border-bottom: none;
	}
}

.card-label {
	font-size: 26px;
	color: #606266;
	font-weight: 500;
}

.card-value {
	font-size: 26px;
	color: #303133;
	font-weight: 600;

	&.balance {
		color: #e6a23c;
	}

	&.desc {
		color: #059669;
		font-weight: 500;
	}
}

.empty-tip {
	text-align: center;
	color: #909399;
	font-size: 24px;
	padding: 40px 0;
}

::v-deep .van-cell-group {
	.van-cell {
		font-size: 26px;
		padding: 24px;
	}
}
</style>
